import { lazy } from 'react'

import { RouteConfig } from 'packages/route'

/**
 * 路由注册
 *
 * @returns 注册信息
 */
export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/gatewayManagement',
    name: 'AdminGatewayManagement',
    getTitle: () => '门户管理',
    component: lazy(() =>
      import('./pages/index').then((m) => ({
        default: m.GatewayManagement,
      }))
    ),
  },
  {
    name: 'AdminSystemPlugins',
    path: 'admin/gatewayManagement/systemPlugins',
    getTitle: () => '应用商店',
    component: lazy(() =>
      import('./pages/SystemPlugins').then((m) => ({
        default: m.SystemPlugins,
      }))
    ),
  },
]
